import { render, staticRenderFns } from "./MeasurementRow.vue?vue&type=template&id=24cc7a46&scoped=true&"
import script from "./MeasurementRow.vue?vue&type=script&lang=js&"
export * from "./MeasurementRow.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementRow.vue?vue&type=style&index=0&id=24cc7a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc7a46",
  null
  
)

export default component.exports